import React from "react";
import { colorFor } from "../lib/saddleColors";

export const SaddleCloth = ({ n }) => {
  const c = colorFor(n);
  return (
    <div
      data-testid={`saddle-${n}`}
      className="flex items-center justify-center font-bold tabular-nums"
      style={{
        backgroundColor: c.bg,
        color: c.fg,
        border: `1.5px solid ${c.border}`,
        width: "44px",
        height: "36px",
        borderRadius: "4px",
        fontSize: "18px",
        letterSpacing: "0.02em",
        boxShadow: "inset 0 -2px 0 rgba(0,0,0,0.08)",
      }}
    >
      {n}
    </div>
  );
};
